export default __webpack_public_path__ + "static/media/rocket.4044e70e.png";